import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Users, Smartphone, Tablet } from "lucide-react";
import { WaiterSessionsCard } from "./WaiterSessionsCard";
import { useWaiterSessionsManagement } from "@/hooks/useWaiterSessionsManagement";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface WaiterSessionsDialogProps {
  triggerClassName?: string;
}

export function WaiterSessionsDialog({ triggerClassName }: WaiterSessionsDialogProps) {
  const [open, setOpen] = useState(false);
  const { pendingRequests, activeWaiterSessions, activeTabletSessions } = useWaiterSessionsManagement();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className={triggerClassName}>
          <Users className="h-4 w-4 mr-2" />
          Garçons
          {pendingRequests.length > 0 && (
            <Badge variant="destructive" className="ml-2 h-5 w-5 p-0 flex items-center justify-center text-xs">
              {pendingRequests.length}
            </Badge>
          )}
          <TooltipProvider>
            {activeWaiterSessions.length > 0 && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <Badge className="ml-1 h-5 min-w-5 px-1 flex items-center justify-center gap-0.5 text-xs bg-green-600 hover:bg-green-600">
                    <Smartphone className="h-3 w-3" />
                    {activeWaiterSessions.length}
                  </Badge>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{activeWaiterSessions.length} garçom(ns) ativo(s)</p>
                </TooltipContent>
              </Tooltip>
            )}
            {activeTabletSessions.length > 0 && (
              <Tooltip>
                <TooltipTrigger asChild>
                  <Badge className="ml-1 h-5 min-w-5 px-1 flex items-center justify-center gap-0.5 text-xs bg-purple-600 hover:bg-purple-600">
                    <Tablet className="h-3 w-3" />
                    {activeTabletSessions.length}
                  </Badge>
                </TooltipTrigger>
                <TooltipContent>
                  <p>{activeTabletSessions.length} tablet(s) ativo(s)</p>
                </TooltipContent>
              </Tooltip>
            )}
          </TooltipProvider>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="sr-only">Gerenciar Garçons</DialogTitle>
        </DialogHeader>
        <WaiterSessionsCard />
      </DialogContent>
    </Dialog>
  );
}
